import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import HitCard from 'Components/Cards/HitCard';
import ViewAllCard from 'Components/Cards/ViewAllCard';
import SkeletonHitCard from 'Components/Cards/SkeletonHitCard';
import imageSizes from 'Components/Cards/image-sizes';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';

function ProductCarousel({
  hitData,
  hitCardLightTheme,
  slidesToShow,
  place,
  viewAllLocation,
  viewAllTitle,
  showFlashDealBar,
  showFakeCards,
  lazyLoadCover,
  hitCardNameTag,
  carouselCoverSize,
  sliderSettings,
}) {
  if (!hitData) return false;

  if (isEmpty(hitData) && showFakeCards) {
    return (
      <SiteSlider sliderSettings={sliderSettings} sliderClass="ProductCardCarousel">
        {[...Array(12).keys()].map(fakeHit =>
          <SkeletonHitCard
            key={fakeHit + 1}
            numberOfCards={1}
            xsSize={12}
            smSize={12}
            mdSize={12}
            lgSize={12}
            showFlashDealBar={showFlashDealBar}
            coverType={carouselCoverSize}
          />,
        )}
      </SiteSlider>
    );
  }

  // Calculate image sizes separately
  let sizesOverride = imageSizes(4, 6, 6, 12);
  if (slidesToShow === 2) {
    sizesOverride = imageSizes(6, 6, 6, 12);
  }
  if (slidesToShow === 4) {
    sizesOverride = imageSizes(3, 6, 6, 12);
  }
  let hitDataLength = hitData.length;
  if (viewAllLocation && viewAllLocation !== 'wishlist' && hitDataLength >= (slidesToShow * 3)) (hitDataLength -= 1);
  if (viewAllLocation && viewAllLocation === 'wishlist' && hitDataLength === 15) (hitDataLength -= 1);

  let showViewAllCard = false;
  if (viewAllLocation && viewAllLocation !== '') showViewAllCard = true;

  return (
    <SiteSlider sliderSettings={sliderSettings} sliderClass="ProductCardCarousel">
      {hitData.slice(0, hitDataLength).map(hit =>
        <HitCard
          key={hit.product_id}
          showFlashDealBar={showFlashDealBar}
          hitCardLightTheme={hitCardLightTheme}
          xsSize={12}
          smSize={12}
          mdSize={12}
          lgSize={12}
          sizesOverride={sizesOverride}
          hit={hit}
          place={place}
          lazy={lazyLoadCover}
          hitCardNameTag={hitCardNameTag}
          coverTypeOverride={carouselCoverSize}
          adaptiveSize={carouselCoverSize === 'portrait' || carouselCoverSize === 'square'}
        />,
      )}
      {showViewAllCard &&
        <ViewAllCard
          key={`view-all-${viewAllLocation}`}
          title={viewAllTitle}
          location={viewAllLocation}
          cardAspectSize={carouselCoverSize}
          showFlashDealBar={showFlashDealBar}
        />
      }
    </SiteSlider>
  );
}

ProductCarousel.propTypes = {
  hitData: PropTypes.arrayOf(PropTypes.shape),
  hitCardLightTheme: PropTypes.bool,
  slidesToShow: PropTypes.number,
  place: PropTypes.string, // where the ProductCarousel is placed on within the website
  viewAllLocation: PropTypes.string, // path which the last item in the carousel should link to
  viewAllTitle: PropTypes.string,
  showFlashDealBar: PropTypes.bool,
  showFakeCards: PropTypes.bool,
  lazyLoadCover: PropTypes.bool,
  hitCardNameTag: PropTypes.string,
  carouselCoverSize: PropTypes.oneOf([
    '',
    '16x9',
    'portrait',
    'square',
  ]),
  sliderSettings: PropTypes.shape({}),
};

ProductCarousel.defaultProps = {
  hitData: [],
  hitCardLightTheme: false,
  place: '',
  slidesToShow: 3,
  viewAllLocation: '',
  viewAllTitle: '',
  showFlashDealBar: false,
  showFakeCards: false,
  lazyLoadCover: true,
  hitCardNameTag: 'div',
  carouselCoverSize: '',
  sliderSettings: {},
};

export default ProductCarousel;
